import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@3plearning/react-components';
import { useDispatch } from 'react-redux';
import { t } from '@lingui/macro';
import { UnAssignIcon, IconUnassignAll } from '../../helpers/icon-dictionary';
import ActionsList from '../actions-list';
import OutsideClickHandler from '../../helpers/hoc/close/outside-click-handler';
import Resources from '../../helpers/resources';
import { getTopics } from '../../containers/course-assign/course-assign-actions';
import { ERROR_DETECTED } from '../../containers/course-assign/course-assign-types';
import { retrieveAssignedTaskId } from '../../helpers/resources-helper';
import { showToast } from '../toast/toast-action';
import { SHOW_UNASSIGN_MODAL } from '../unassign-all-modal/store/unassign-all-modal.actions';
import { useTracking } from '../../analytics';

function UnassignButton(props) {
  const { i18n } = props;
  const dispatch = useDispatch();
  const { trackMenuAction } = useTracking();
  const [isUnassignActionsOpen, setUnassignActionsOpen] = useState(false);

  const unassignButtonText = `${i18n._(t('footer.unassign')`Unassign`)} (${
    props.assignmentsToUnassign.length
  })`;

  const unassignActionsListOptions = [
    {
      icon: UnAssignIcon,
      disabled: props.assignmentsToUnassign.length === 0,
      text: i18n._(t('footer.unassign')`Unassign`),
      subtext: i18n._(
        t('footer.unassignSelectedSub')`Selected student activities`
      ),
      onClick: () => {
        trackMenuAction({ action: 'unassign' });
        handleUnassign();
      }
    },
    {
      icon: IconUnassignAll,
      text: i18n._(t('footer.unassignAll')`Unassign All`),
      subtext: i18n._(
        t('footer.unassignEverythingSub')`Everything for this class and group`
      ),
      onClick: () => {
        trackMenuAction({ action: 'unassign-all' });
        dispatch({ type: SHOW_UNASSIGN_MODAL });
      }
    }
  ];

  function handleSuccess() {
    const { classroomId, groupId } = props;
    dispatch(getTopics(classroomId, groupId));
    setUnassignActionsOpen(false);
  }

  function handleUnassign() {
    const { classroomId, groupId, assignmentsToUnassign } = props;
    Resources.unassign
      .put({ classroomId, groupId })
      .withBody({
        assignedTaskIdList: retrieveAssignedTaskId(assignmentsToUnassign)
      })
      .send()
      .then(
        () => {
          handleSuccess();
          dispatch(
            showToast(
              i18n._(
                t(
                  'footer.unassignSuccess'
                )`Selected student activities have been unassigned`
              ),
              'success'
            )
          );
        },
        (err) => {
          dispatch({
            type: ERROR_DETECTED,
            payload: err
          });
        }
      );
  }

  return (
    <div className="unassign">
      <OutsideClickHandler
        callback={() => setUnassignActionsOpen(false)}
        forButton="unassignActions"
      >
        <div
          className="actionsContainer"
          id="unassignActions"
          data-testid="unassign-button"
        >
          <Button
            className="button"
            disabled={props.actionInProgress}
            primary
            text={unassignButtonText}
            type={Button.LOZENGE}
            onClick={() => setUnassignActionsOpen(!isUnassignActionsOpen)}
            alignIcon="LEFT"
            icon={UnAssignIcon}
          />
          <ActionsList
            options={unassignActionsListOptions}
            isOpen={isUnassignActionsOpen}
            isWide
            shouldOpenUp
          />
        </div>
      </OutsideClickHandler>
    </div>
  );
}

UnassignButton.propTypes = {
  i18n: PropTypes.object,
  actionInProgress: PropTypes.bool,
  assignmentsToUnassign: PropTypes.arrayOf(PropTypes.object),
  classroomId: PropTypes.number,
  groupId: PropTypes.number
};

export default UnassignButton;



// WEBPACK FOOTER //
// ./components/unassign-button/index.js